import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ClickAwayListener, Menu, Slide, Typography } from "@mui/material";
import { useRef, useState } from "react";
import BryxColors from "../../types/theme";
import BryxIcon from "../BryxIcon/BryxIcon";
import { BryxActionMenuTransitionTime, getOriginPropsForElement } from "./BryxActionMenu";
import BryxActionMenuItem from "./BryxActionMenuItem";
const BryxNestedActionMenuItem = (props) => {
    const { parentMenuOpen, label, children, className, stopPropagation, ContainerProps: ContainerProps = {}, ...MenuItemProps } = props;
    const containerRef = useRef(null);
    const menuContainerRef = useRef(null);
    const [isSubMenuOpen, setIsSubMenuOpen] = useState(false);
    const handleClickEnter = (e) => {
        setIsSubMenuOpen((prevState) => !prevState);
        stopPropagation && e.stopPropagation();
    };
    const handleClickLeave = (e) => {
        setIsSubMenuOpen(false);
        stopPropagation && e.stopPropagation();
    };
    const open = isSubMenuOpen && parentMenuOpen;
    const { anchorOriginProps, transformOriginProps, isLeft } = getOriginPropsForElement(containerRef.current);
    return (_jsx("div", { ...ContainerProps, className: className, ref: containerRef, children: _jsx(ClickAwayListener, { onClickAway: handleClickLeave, children: _jsxs(_Fragment, { children: [_jsx(BryxActionMenuItem, { ...MenuItemProps, onClick: handleClickEnter, isOpen: open, content: _jsxs("span", { style: { display: "inline-flex", alignItems: "center", justifyContent: "space-between", width: "100%" }, children: [_jsx(Typography, { noWrap: true, sx: (theme) => ({
                                        fontSize: "13px",
                                        color: BryxColors.notify(theme.palette.mode, "inactive"),
                                    }), children: label }), _jsx(BryxIcon, { iconName: "keyboard_arrow_right_rounded", mdIconSize: true, sx: { marginRight: "2px" } })] }) }), _jsx(Menu, { anchorEl: containerRef.current, open: open, disableAutoFocus: true, disableAutoFocusItem: true, onClose: () => {
                            setIsSubMenuOpen(false);
                        }, anchorOrigin: {
                            vertical: "top",
                            ...anchorOriginProps,
                        }, transformOrigin: {
                            vertical: "top",
                            ...transformOriginProps,
                        }, PaperProps: {
                            style: {
                                width: "167px",
                            },
                        }, children: _jsx("div", { ref: menuContainerRef, style: { pointerEvents: "all" }, children: _jsx(Slide, { direction: isLeft ? "right" : "left", container: menuContainerRef.current, timeout: BryxActionMenuTransitionTime, in: open, enter: true, exit: true, mountOnEnter: true, children: _jsx("div", { children: children }) }) }) })] }) }) }));
};
export default BryxNestedActionMenuItem;
